import { render } from "./StageActivity.vue?vue&type=template&id=82abcf70&scoped=true"
import script from "./StageActivity.vue?vue&type=script&lang=js"
export * from "./StageActivity.vue?vue&type=script&lang=js"

import "./StageActivity.vue?vue&type=style&index=0&id=82abcf70&scoped=true&lang=css"

import exportComponent from "C:\\Users\\bfern\\Documents\\la-vuelta-trama\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82abcf70"]])

export default __exports__